import { useEffect, useState } from "react"
import { apiBaseUrl } from "@/config/api";

export function useCheckSubdomain() {
    const [domainValid, setDomainValid] = useState<boolean | null>(null)

    useEffect(() => {
        const hostname = window.location.hostname
        const subdomain = hostname.split(".")[0]
        if (subdomain === "admin") {
            setDomainValid(true)
            return
        }

        if (hostname.includes(".icont.ai")) {
            fetch(`${apiBaseUrl}/authentication/check-subdomain?company_domain=${subdomain}`)
                .then((res) => {
                    if (res.status === 200) {
                        setDomainValid(true)
                    } else {
                        setDomainValid(false)
                    }
                })
                .catch(() => setDomainValid(false))
        } else {
            setDomainValid(true) // development, localhost etc
        }
    }, [])

    return domainValid
}
